import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './work-experience.reducer';

export const WorkExperienceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const workExperienceEntity = useAppSelector(state => state.workExperience.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="workExperienceDetailsHeading">
          <Translate contentKey="fivePlusApp.workExperience.detail.title">WorkExperience</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{workExperienceEntity.id}</dd>
          <dt>
            <span id="position">
              <Translate contentKey="fivePlusApp.workExperience.position">Position</Translate>
            </span>
          </dt>
          <dd>{workExperienceEntity.position}</dd>
          <dt>
            <span id="employerName">
              <Translate contentKey="fivePlusApp.workExperience.employerName">Employer Name</Translate>
            </span>
          </dt>
          <dd>{workExperienceEntity.employerName}</dd>
          <dt>
            <span id="employmentType">
              <Translate contentKey="fivePlusApp.workExperience.employmentType">Employment Type</Translate>
            </span>
          </dt>
          <dd>{workExperienceEntity.employmentType}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="fivePlusApp.workExperience.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>
            {workExperienceEntity.startDate ? (
              <TextFormat value={workExperienceEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="fivePlusApp.workExperience.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {workExperienceEntity.endDate ? (
              <TextFormat value={workExperienceEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="isPresentJob">
              <Translate contentKey="fivePlusApp.workExperience.isPresentJob">Is Present Job</Translate>
            </span>
          </dt>
          <dd>{workExperienceEntity.isPresentJob ? 'true' : 'false'}</dd>
          <dt>
            <span id="employeeLogo">
              <Translate contentKey="fivePlusApp.workExperience.employeeLogo">Employee Logo</Translate>
            </span>
          </dt>
          <dd>{workExperienceEntity.employeeLogo}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.workExperience.user">User</Translate>
          </dt>
          <dd>{workExperienceEntity.user ? workExperienceEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/work-experience" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/work-experience/${workExperienceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WorkExperienceDetail;
